import React, { Component } from 'react'

export default class Footer extends Component {
   
    render() {
        return (
            <div>
                <p>Footer</p>
            </div>
        )
    }
}
